/**
 * @generated SignedSource<<56236a917c3ce3ecc8a51acd2cbbc360>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGoToStore_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club?: {
        readonly " $fragmentSpreads": FragmentRefs<"useIsClubSellingMemberships_club" | "useIsClubSellingStandardPackages_club">;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGoToStore_session";
};
export type useGoToStore_session$key = {
  readonly " $data"?: useGoToStore_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGoToStore_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGoToStore_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "useIsClubSellingStandardPackages_club"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "useIsClubSellingMemberships_club"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "ed9ae12ad315d3639d1cd81aa7698b1a";

export default node;
